module.exports = __webpack_public_path__ + "img/dr2.png";